// extracted by mini-css-extract-plugin
export default {"container":"UpdateMetadataHeader_container__Cyd4j","description":"UpdateMetadataHeader_description__MI7Cr"};